/**
 * 简单国际化工具（中文 / 印尼语）
 *
 * 使用方式：
 *   import { t, setLang, getLang } from '@/utils/i18n'
 *   t('login.title')  // 返回当前语言的文本
 *   setLang('id')     // 切换到印尼语
 */

const DEFAULT_LANG = 'id'

const messages = {
  // 中文
  zh: {
    login: {
      title: 'IPIP杰出之星投票',
      subtitle: '请使用账号密码登录',
      usernamePlaceholder: '请输入用户名/手机号',
      passwordPlaceholder: '请输入密码',
      loginBtn: '登 录',
      loggingIn: '登录中...',
      footer: '仅限IPIP园区内部员工使用',
      dingtalkLoading: '正在通过钉钉自动登录...',
      dingtalkFail: '钉钉自动登录失败，请使用账号密码登录',
      dingtalkLoginFail: '钉钉登录失败',
      usernameRequired: '请输入用户名/手机号',
      passwordRequired: '请输入密码',
      loginSuccess: '登录成功',
      networkError: '网络错误，请重试',
      accountError: '账号或密码错误',
      adminLoginHint: '请输入密码登录管理后台',
      adminMobileLabel: '手机号（钉钉账号）'
    },
    rules: {
      title: '投票规则',
      subtitle: '投票规则',
      agree: '已阅读并同意',
      startBtn: '开始投票',
      lottery: '参与投票，抽奖资格同步生效！您就与大奖之间只差一次点击的距离。'
    },
    vote: {
      title: '杰出之星评选',
      candidates: '候选人',
      companies: '公司',
      required: '必选',
      detail: '详情',
      close: '关闭',
      noDesc: '暂无详细介绍',
      rulesTip: '一账号一票 · 提交后不可修改 · 系统监测异常刷票',
      progress: '投票进度',
      submit: '提交投票',
      needMore: '还需',
      maxSelected: '最多选10位',
      quotaFull: '配额已满',
      selectMessage: '请选择10位候选人',
      voteSuccess: '投票成功！',
      voteUnit: '票'
    },
    rulesDialog: {
      title: '投票规则',
      sub: '请仔细阅读',
      lottery: '参与投票即可参与抽奖，投票成功后自动开奖！',
      confirm: '我知道了'
    },
    lang: {
      label: '语言',
      zh: '中文',
      id: '印尼语'
    }
  },

  // 印尼语
  id: {
    login: {
      title: 'Voting Bintang Terbaik IPIP',
      subtitle: 'Silakan login dengan akun Anda',
      usernamePlaceholder: 'Masukkan nama pengguna/nomor HP',
      passwordPlaceholder: 'Masukkan kata sandi',
      loginBtn: 'Masuk',
      loggingIn: 'Memproses...',
      footer: 'Hanya untuk karyawan internal IPIP',
      dingtalkLoading: 'Login otomatis melalui DingTalk...',
      dingtalkFail: 'Login DingTalk gagal, silakan gunakan akun',
      dingtalkLoginFail: 'Login DingTalk gagal',
      usernameRequired: 'Masukkan nama pengguna/nomor HP',
      passwordRequired: 'Silakan masukkan kata sandi',
      loginSuccess: 'Login berhasil',
      networkError: 'Kesalahan jaringan, silakan coba lagi',
      accountError: 'Nama pengguna atau kata sandi salah',
      adminLoginHint: 'Silakan masukkan kata sandi untuk login',
      adminMobileLabel: 'Nomor HP (Akun DingTalk)'
    },
    rules: {
      title: 'Aturan Pemungutan Suara',
      subtitle: 'Aturan Pemungutan Suara',
      agree: 'Telah membaca & setuju',
      startBtn: 'Mulai',
      lottery: 'Voting = kesempatan undian! Hanya satu klik antara Anda dan hadiah utama.'
    },
    vote: {
      title: 'Penghargaan Bintang Unggulan',
      candidates: 'Kandidat',
      companies: 'Perusahaan',
      required: 'Wajib',
      detail: 'Detail',
      close: 'Tutup',
      noDesc: 'Belum ada deskripsi',
      rulesTip: 'Satu akun satu suara · Terkunci · Anti-cheat',
      progress: 'Progress',
      submit: 'Kirim',
      needMore: 'Kurang',
      maxSelected: 'Maksimal 10',
      quotaFull: 'Kuota penuh',
      selectMessage: 'Pilih 10 kandidat',
      voteSuccess: 'Voting berhasil!',
      voteUnit: 'suara'
    },
    rulesDialog: {
      title: 'Aturan',
      sub: 'Harap baca dengan seksama',
      lottery: 'Ikut voting = ikut undian hadiah otomatis!',
      confirm: 'Saya mengerti'
    },
    lang: {
      label: 'Bahasa',
      zh: 'Mandarin',
      id: 'Indonesia'
    }
  }
}

/**
 * 获取当前语言
 */
export function getLang () {
  return localStorage.getItem('app_lang') || DEFAULT_LANG
}

/**
 * 设置语言
 */
export function setLang (lang) {
  localStorage.setItem('app_lang', lang)
}

/**
 * 翻译函数
 * @param {string} key 如 'login.title'
 * @returns {string}
 */
export function t (key) {
  const lang = getLang()
  const keys = key.split('.')
  let value = messages[lang]
  for (const k of keys) {
    if (value && value[k] !== undefined) {
      value = value[k]
    } else {
      // 降级到中文
      value = messages.zh
      for (const k2 of keys) {
        if (value && value[k2] !== undefined) {
          value = value[k2]
        } else {
          return key
        }
      }
      break
    }
  }
  return typeof value === 'string' ? value : key
}

export default { t, setLang, getLang }



// WEBPACK FOOTER //
// ./src/utils/i18n.js